import * as React from 'react';
import { formatScreamingSnakesToPrettyStrings } from 'task-manager/formatScreamingSnakesToPrettyStrings';
import { Label } from 'task-manager/TaskFilters.styles';
import { getJobTypesForTeam } from 'task-manager/teamJobLookup';
import { JobType, Team } from 'task-manager/types';
import { ArrayParam, StringParam, useQueryParam } from 'use-query-params';
import { handleUndefinedFilter } from './utils';

type JobFilterProps = {
  handleSelectChange: (value: string | string[], name: string) => void;
};

export const JobFilter = ({ handleSelectChange }: JobFilterProps) => {
  const [jobTypes] = useQueryParam('jobTypes', ArrayParam);
  const [team] = useQueryParam('team', StringParam);
  const jobTypeOptions = team ? getJobTypesForTeam(Team[team]) : [];
  return (
    <span key={'jobFilter'}>
      <Label>Job</Label>
      <select
        aria-label="jobTypes dropdown"
        name="jobTypes"
        value={handleUndefinedFilter(jobTypes)}
        onChange={({ target: { value, name } }) =>
          handleSelectChange(JobType[value] ? [value] : value, name)
        }
      >
        <option value={undefined}>All</option>
        {jobTypeOptions.map((type, i) => (
          <option value={type} key={`${i}-${handleUndefinedFilter(team)}-${type}`}>
            {formatScreamingSnakesToPrettyStrings(type)}
          </option>
        ))}
      </select>
    </span>
  );
};
